import React, { useCallback } from 'react';
import { Chip } from '@mui/material';
import ChecklistIcon from '@mui/icons-material/Checklist';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

export const DataGridTaskType = ({ taskType }) => {
	const Icon = useCallback(() => {
		switch (taskType?.toUpperCase()) {
			case 'CALL':
				return <PhoneIcon sx={{ fontSize: '18px' }} />;
			case 'EMAIL':
				return <EmailIcon sx={{ fontSize: '18px' }} />;
			default:
				return <ChecklistIcon sx={{ fontSize: '18px' }} />;
		}
	}, [taskType]);

	return (
		<Chip
			icon={<Icon />}
			size='small'
			label={taskType || 'TODO'}
			sx={{ fontSize: '12px', pl: '8px', '& .MuiChip-label': { pl: '6px' } }}
		/>
	);
};
